import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/sso/login',
    method: 'post',
    data
  })
}

export function loginByThirdSystem(data) {
  return request({
    url: '/sso/loginByThirdSystem?appId=' + data.appId + '&thirdToken=' + data.thirdToken,
    method: 'post'
  })
}

export function getInfo(token) {
  return request({
    url: '/sso/getUserInfo',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/sso/logout',
    method: 'post'
  })
}

// /updatePwd
export function updatePwd(data) {
  return request({
    url: '/sso/updatePwd',
    method: 'put',
    data
  })
}
